// src/app/reducers/notifications.js
const initialState = {
  notification: null // {title:"asfdasd", message: "is automatically loaded by the development server (react-scripts start) if it exists, to set up HTTP proxies (not for polyfills).But your current file only provides polyfills and does not set up any proxy middleware.", type:"Info"}
};

export const SET_NOTIFICATION = "SET_NOTIFICATION";

export function setNotification(notification) {
  return { type: SET_NOTIFICATION, payload: notification };
}

export default function notificationsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_NOTIFICATION:
      return { ...state, notification: action.payload };
    default:
      return state;
  }
}